// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".affiliator-ticket__plug{align-items:center;background:#fff;border-radius:40px;display:flex;flex-direction:row;height:80px;justify-content:center;position:relative}.affiliator-ticket__plug .dotted-loader__dot{background:#003e92}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
